<template>
  <v-tooltip :disabled="!disabled" top>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-btn
          depressed
          class="cta-button"
          :to="to"
          :disabled="disabled"
          :loading="loading"
          @click="doClick($event)"
          v-bind="$attrs"
        >
          <slot></slot>
        </v-btn>
      </div>
    </template>
    <span>{{ disabledTooltipMessage }}</span>
  </v-tooltip>
</template>
<script>
export default {
  methods: {
    doClick(event) {
      this.$emit("click", event);
    }
  },
  props: ["disabled", "disabledTooltipMessage", "to", "loading"]
};
</script>
<style lang="sass" scoped>
.cta-button.v-btn:not(.v-btn--round)
  justify-self: center
  border-radius: 4px
  background-color: $primary !important
  height: 32px

.cta-button.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).theme--light
  background-color: $color-neutrals-navy-100 !important

  ::v-deep .v-btn__content
    color: $color-neutrals-navy-75 !important

.cta-button
  ::v-deep .v-btn__content
    color: white
    font-size: 16px
    font-weight: bold
    line-height: 20px
    text-align: center
    text-transform: none
</style>
